module.exports = __webpack_public_path__ + "static/aws-276dd6a55c34bf333641156910864ad5.png";